import { PaymentType } from './offering-payment-type';
var OfferingPaymentDtoBuilder = /** @class */ (function () {
    function OfferingPaymentDtoBuilder() {
        this.payment = {
            currency: 'USD',
            price: 123,
            isFree: false,
            priceText: 'price text',
            minCharge: 0,
            paymentType: PaymentType.OFFLINE,
        };
    }
    OfferingPaymentDtoBuilder.prototype.withCurrency = function (currency) {
        this.payment.currency = currency;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPrice = function (price) {
        this.payment.price = price;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withIsFree = function (isFree) {
        this.payment.isFree = isFree;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPriceText = function (priceText) {
        this.payment.priceText = priceText;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withMinCharge = function (minCharge) {
        this.payment.minCharge = minCharge;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPaymentType = function (paymentType) {
        this.payment.paymentType = paymentType;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.build = function () {
        return this.payment;
    };
    return OfferingPaymentDtoBuilder;
}());
export { OfferingPaymentDtoBuilder };
//# sourceMappingURL=offering-payment.dto.buillder.js.map